export const POS_SIZING_ATOMIC_PUBLICATION_CONTRACT = 'pos-sizing-atomic-publication.v1';
export const POS_SIZING_FILE_UPLOAD_MODE = 'file_upload';
export const POS_SIZING_ACTUAL_SYNC_MODE = 'actual_sync';
export const POS_SIZING_WATCHLIST_START_MODE = 'watchlist_start';

export const isValidPosSizingPublicationBase = (base) => {
    if (!base || typeof base !== 'object' || Array.isArray(base)) return false;
    const keys = Object.keys(base).sort();
    if (JSON.stringify(keys) !== JSON.stringify([
        'portfolio_id',
        'portfolio_row_version',
        'watchlist_revision_id',
    ])) return false;
    const hasPortfolio = (
        Number.isInteger(base.portfolio_id)
        && base.portfolio_id > 0
        && typeof base.portfolio_row_version === 'string'
        && base.portfolio_row_version.trim() === base.portfolio_row_version
        && base.portfolio_row_version.length > 0
    );
    const hasNoPortfolio = (
        base.portfolio_id === null && base.portfolio_row_version === null
    );
    return (
        (hasPortfolio || hasNoPortfolio)
        && typeof base.watchlist_revision_id === 'string'
        && base.watchlist_revision_id.trim() === base.watchlist_revision_id
        && base.watchlist_revision_id.length > 0
    );
};

export const requirePosSizingPublicationCapability = async (callBackend, mode) => {
    const capabilities = await callBackend('pos_sizing_publication_capabilities', 'GET');
    if (
        capabilities?.contract !== POS_SIZING_ATOMIC_PUBLICATION_CONTRACT
        || !Array.isArray(capabilities?.modes)
        || !capabilities.modes.includes(mode)
    ) {
        throw new Error('Position sizing atomic publication is unavailable. Refresh and try again.');
    }
};

export const requireAtomicPublicationReceipt = (response, canonicalRows, mode) => {
    const receipt = response?.receipt;
    const returnedIds = canonicalRows.map((row) => row.cognive_id).sort();
    const receiptIds = Array.isArray(receipt?.canonical_cognive_ids)
        ? [...receipt.canonical_cognive_ids].sort()
        : null;
    const isSha256 = (value) => /^[a-f0-9]{64}$/.test(String(value || ''));
    if (
        receipt?.contract !== POS_SIZING_ATOMIC_PUBLICATION_CONTRACT
        || receipt?.publication_kind !== mode
        || receipt?.committed !== true
        || typeof receipt?.replayed !== 'boolean'
        || !Number.isInteger(receipt?.portfolio_id)
        || receipt.portfolio_id < 1
        || receipt?.canonical_count !== canonicalRows.length
        || !isSha256(receipt?.canonical_scope_digest)
        || !/^psv3:[a-f0-9]{64}$/.test(String(receipt?.pos_sizing_state_hash || ''))
        || typeof receipt?.watchlist_revision_id !== 'string'
        || !receipt.watchlist_revision_id.trim()
        || !Number.isInteger(receipt?.watchlist_revision_seq)
        || receipt.watchlist_revision_seq < 0
        || !isSha256(receipt?.watchlist_scope_digest)
        || !isSha256(receipt?.watchlist_state_hash)
        || typeof receipt?.watchlist_pointer_version !== 'string'
        || !receipt.watchlist_pointer_version.trim()
        || typeof receipt?.factor_context_id !== 'string'
        || !receipt.factor_context_id.trim()
        || !isSha256(receipt?.factor_context_digest)
        || !isSha256(receipt?.snapshot_digest)
        || !isSha256(receipt?.candidate_metadata_digest)
        || !isValidPosSizingPublicationBase(receipt?.publication_base)
        || receipt.portfolio_id !== receipt?.publication_base?.portfolio_id
        || receipt.watchlist_revision_id !== receipt?.publication_base?.watchlist_revision_id
        || !receiptIds
        || JSON.stringify(receiptIds) !== JSON.stringify(returnedIds)
    ) {
        throw new Error('Position sizing publication did not return a complete committed receipt.');
    }
    return receipt;
};
